export interface BankOption {
  name: string;
  minNum: number;
  maxNum: number;
}

export const starterPages: string[] = [
  // 'email-verification',
  'store-owner',
  'store-type',
  // 'business-hours',
  // 'store-details',
  'address-info',
  // 'pickup-address',
  // 'account-details',
  'bank-details',
];

export const bankOptions: BankOption[] = [
  { name: 'ANZ Bank (Thai) Public Company Limited', minNum: 10, maxNum: 16 },
  { name: 'Bangkok Bank Public Company Limited', minNum: 10, maxNum: 16 },
  { name: 'Bank for Agriculture and Agricultural', minNum: 10, maxNum: 16 },
  { name: 'Bank of America National Association', minNum: 10, maxNum: 16 },
  { name: 'Bank of Ayudhya Public Company Limited', minNum: 10, maxNum: 16 },
  { name: 'Bank of China ( Thai ) Public Company Limited', minNum: 10, maxNum: 16 },
  { name: 'Bank of Thailand', minNum: 10, maxNum: 16 },
  { name: 'BNP Paribas Bank', minNum: 10, maxNum: 16 },
  { name: 'CIMB Thai Bank Public Company Limited', minNum: 10, maxNum: 16 },
  { name: 'Citibank N.A.', minNum: 10, maxNum: 16 },
  { name: 'Deutsche Bank Aktiengesellschaft', minNum: 10, maxNum: 16 },
  { name: 'Government Housing Bank', minNum: 10, maxNum: 16 },
  { name: 'Government Saving Bank', minNum: 10, maxNum: 16 },
  { name: 'Hong Kong & Shanghai Corporation Limited', minNum: 10, maxNum: 16 },
  { name: 'ICBC Thai Commercial Bank', minNum: 10, maxNum: 16 },
  { name: 'Islamic Bank of Thailand', minNum: 10, maxNum: 16 },
  { name: 'JP Morgan Chase Bank', minNum: 10, maxNum: 16 },
  { name: 'Kasikornbank Public CompanyLimited', minNum: 10, maxNum: 16 },
  { name: 'Kiatnakin Bank Public Company Limited', minNum: 10, maxNum: 16 },
  { name: 'Krung Thai Bank Public Company Limited', minNum: 10, maxNum: 16 },
  { name: 'Land and Houses Bank Public Company Limited', minNum: 10, maxNum: 16 },
  { name: 'Mega International Commercial Bank PCL', minNum: 10, maxNum: 16 },
  { name: 'Mizuho Corporate Bank Limited', minNum: 10, maxNum: 16 },
  { name: 'Siam Commercial Bank Public Company Limited', minNum: 10, maxNum: 16 },
  { name: 'Standard Chartered Bank (Thai) Public', minNum: 10, maxNum: 16 },
  { name: 'Sumitomo Mitsui Banking Corporation', minNum: 10, maxNum: 16 },
  { name: 'The Royal Bank of Scotland N.V.', minNum: 10, maxNum: 16 },
  { name: 'The Thai Credit Retail Bank Public Company', minNum: 10, maxNum: 16 },
  { name: 'Tisco Bank Public Company Limited', minNum: 10, maxNum: 16 },
  { name: 'TTB Bank', minNum: 10, maxNum: 16 },
  { name: 'United Overseas Bank (Thai) PCL', minNum: 10, maxNum: 16 }
];
